// composables/useToast.ts

import { ref, readonly } from 'vue'
import { trans } from 'laravel-vue-i18n'

// De interface blijft hetzelfde
export interface ToastMessage {
    id: number
    message: string
    type?: 'success' | 'error' | 'warning' | 'info'
    duration?: number
}

// De centrale state blijft hetzelfde
const toasts = ref<ToastMessage[]>([])

// We maken een algemene 'add' functie die we intern gebruiken
const addToast = (toastInfo: Omit<ToastMessage, 'id'>) => {
    const id = Date.now() + Math.random()
    const defaultDuration = 5000

    toasts.value.unshift({
        ...toastInfo,
        id: id,
    })

    const duration = toastInfo.duration ? toastInfo.duration * 1000 : defaultDuration
    if (duration > 0) {
        setTimeout(() => {
            removeToast(id)
        }, duration)
    }
}

const removeToast = (id: number) => {
    toasts.value = toasts.value.filter((toast) => toast.id !== id)
}

// De geëxporteerde functie geeft nu een object terug dat we 'toast' kunnen noemen
export function useToast() {
    return {
        // De lijst met toasts, nog steeds readonly
        toasts: readonly(toasts),

        // De algemene add-functie voor flexibiliteit
        add: addToast,

        // Handige helper-functies voor veelvoorkomende types
        success: (message: string, duration?: number) => {
            addToast({ message: trans(message), type: 'success', duration })
        },
        error: (message: string, duration?: number) => {
            addToast({ message: trans(message), type: 'error', duration })
        },
        warning: (message: string, duration?: number) => {
            addToast({ message: trans(message), type: 'warning', duration })
        },
        info: (message: string, duration?: number) => {
            addToast({ message: trans(message), type: 'info', duration })
        },

        // De remove-functie als je die handmatig nodig hebt
        remove: removeToast,
    }
}
